(function () {
  'use strict';
  if (window.GDShippingUI) return;

  var revision = 0;
  var dependencies = {};
  var quotedRate = null;

  function publishQuote(quote) {
    quotedRate = quote;
    updateSummaries();
    document.dispatchEvent(new CustomEvent('gd:shipping:quote', { detail: { quote: quote } }));
  }

  function currentQuote(currency) {
    return quotedRate && quotedRate.currency === currency && Number.isFinite(quotedRate.price) && quotedRate.price >= 0 ? quotedRate : null;
  }

  function estimateSubtotal(base, quote, currency) {
    var shipping = quote && quote.currency === currency && Number.isFinite(quote.price) && quote.price >= 0 ? quote.price : 0;
    return Number(base || 0) + shipping;
  }

  function addDrawerSummary(footer) {
    var row = document.createElement('p');
    row.className = 'gd-cart-drawer__shipping-estimate';
    row.dataset.gdDrawerShippingSummary = '';
    row.hidden = true;
    var label = document.createElement('span');
    label.dataset.gdShippingSummaryLabel = '';
    var value = document.createElement('strong');
    value.dataset.gdShippingSummaryValue = '';
    row.appendChild(label);
    row.appendChild(value);
    footer.appendChild(row);
    var note = document.createElement('small');
    note.className = 'gd-cart-drawer__shipping-note';
    note.dataset.gdDrawerShippingNote = '';
    note.textContent = 'Valor sujeito à confirmação no checkout.';
    note.hidden = true;
    footer.appendChild(note);
  }

  function updateSummaries() {
    if (!dependencies.money) return;
    var drawerTotal = document.querySelector('[data-gd-drawer-estimated-total]');
    if (drawerTotal) {
      var currency = drawerTotal.dataset.gdCurrency;
      var quote = currentQuote(currency);
      drawerTotal.textContent = dependencies.money(estimateSubtotal(drawerTotal.dataset.gdBaseTotal, quote, currency), currency);
      var original = document.querySelector('[data-gd-drawer-original-total]');
      if (original) original.textContent = dependencies.money(estimateSubtotal(original.dataset.gdBaseTotal, quote, currency), currency);
      var subtotalLabel = document.querySelector('[data-gd-drawer-subtotal-label]');
      if (subtotalLabel) subtotalLabel.textContent = quote ? 'Subtotal estimado (com frete)' : 'Subtotal';
      var drawerShipping = document.querySelector('[data-gd-drawer-shipping-summary]');
      if (drawerShipping) {
        drawerShipping.hidden = !quote;
        var drawerShippingNote = document.querySelector('[data-gd-drawer-shipping-note]');
        if (drawerShippingNote) drawerShippingNote.hidden = !quote;
        if (quote) {
          drawerShipping.querySelector('[data-gd-shipping-summary-label]').textContent = (quote.multiple ? 'Frete a partir de' : 'Frete estimado') + ' (' + quote.name + ')';
          drawerShipping.querySelector('[data-gd-shipping-summary-value]').textContent = dependencies.money(quote.price, currency);
        }
      }
    }
    var page = document.querySelector('[data-gd-cart-page]');
    if (page) {
      var pageCurrency = page.dataset.gdCartCurrency;
      var pageQuote = currentQuote(pageCurrency);
      var estimatedTotal = estimateSubtotal(page.dataset.gdCartBaseTotal, pageQuote, pageCurrency);
      var pageTotal = page.querySelector('[data-gd-cart-total]');
      var pageEstimatedTotal = page.querySelector('[data-gd-cart-estimated-total]');
      var pageSubtotalLabel = page.querySelector('[data-gd-cart-subtotal-label]');
      var pageShipping = page.querySelector('[data-gd-page-shipping-summary]');
      if (pageTotal) pageTotal.textContent = dependencies.money(estimatedTotal, pageCurrency);
      if (pageEstimatedTotal) pageEstimatedTotal.textContent = dependencies.money(estimatedTotal, pageCurrency);
      if (pageSubtotalLabel) pageSubtotalLabel.textContent = pageQuote ? 'Subtotal estimado (com frete)' : 'Subtotal';
      if (pageShipping) {
        pageShipping.hidden = !pageQuote;
        if (pageQuote) {
          pageShipping.querySelector('[data-gd-shipping-summary-label]').textContent = (pageQuote.multiple ? 'Frete a partir de' : 'Frete estimado') + ' (' + pageQuote.name + ')';
          pageShipping.querySelector('[data-gd-shipping-summary-value]').textContent = dependencies.money(pageQuote.price, pageCurrency);
        }
      }
    }
  }

  function lowestRate(rates) {
    var priced = (rates || []).filter(function (rate) {
      return rate && rate.price !== '' && rate.price != null && Number.isFinite(Number(rate.price)) && Number(rate.price) >= 0;
    });
    if (!priced.length) return null;
    return {
      rate: priced.reduce(function (lowest, rate) {
        return Number(rate.price) < Number(lowest.price) ? rate : lowest;
      }),
      multiple: priced.length > 1
    };
  }

  function calculators() {
    return document.querySelectorAll('[data-gd-shipping-calculator]');
  }

  function formatPostal(value) {
    var digits = String(value || '').replace(/\D/g, '').slice(0, 8);
    return digits.length > 5 ? digits.slice(0, 5) + '-' + digits.slice(5) : digits;
  }

  function findFreeRate(rates) {
    return (rates || []).find(function (rate) {
      return rate && rate.price !== '' && rate.price != null && Number(rate.price) === 0;
    }) || null;
  }

  function clearCalculator(calculator) {
    var form = calculator.querySelector('[data-gd-shipping-form]');
    var intro = calculator.querySelector('[data-gd-shipping-intro]');
    var confirmed = calculator.querySelector('[data-gd-shipping-confirmed]');
    var status = calculator.querySelector('[data-gd-shipping-status]');
    var rates = calculator.querySelector('[data-gd-shipping-rates]');
    if (form) form.hidden = false;
    if (intro) intro.hidden = false;
    if (confirmed) confirmed.hidden = true;
    if (status) status.textContent = '';
    if (rates) rates.textContent = '';
    delete calculator.dataset.gdShippingConfirmed;
  }

  function invalidate() {
    revision += 1;
    calculators().forEach(clearCalculator);
    publishQuote(null);
  }

  function setLoading(message) {
    calculators().forEach(function (calculator) {
      clearCalculator(calculator);
      var status = calculator.querySelector('[data-gd-shipping-status]');
      if (status) status.textContent = message;
    });
  }

  function showError(message) {
    calculators().forEach(function (calculator) {
      clearCalculator(calculator);
      var status = calculator.querySelector('[data-gd-shipping-status]');
      if (status) status.textContent = message;
    });
  }

  function showQuote(data, currency, postalCode) {
    var available = data.shipping_rates || [];
    var free = findFreeRate(available);
    calculators().forEach(function (calculator) {
      clearCalculator(calculator);
      var form = calculator.querySelector('[data-gd-shipping-form]');
      var input = form && form.elements.postal_code;
      var intro = calculator.querySelector('[data-gd-shipping-intro]');
      var confirmed = calculator.querySelector('[data-gd-shipping-confirmed]');
      var status = calculator.querySelector('[data-gd-shipping-status]');
      var rates = calculator.querySelector('[data-gd-shipping-rates]');
      if (input) input.value = formatPostal(postalCode);
      if (!available.length) {
        status.textContent = 'Não encontramos opções de entrega para este CEP.';
        return;
      }
      if (free && confirmed) {
        form.hidden = true;
        if (intro) intro.hidden = true;
        confirmed.hidden = false;
        calculator.dataset.gdShippingConfirmed = 'free';
        confirmed.querySelector('[data-gd-shipping-method]').textContent = free.name || 'Entrega';
        confirmed.querySelector('[data-gd-shipping-postal]').textContent = formatPostal(postalCode);
      } else {
        status.textContent = 'Opções de entrega disponíveis:';
      }
      available.forEach(function (rate) {
        var item = document.createElement('li');
        var price = rate.price !== '' && rate.price != null && Number(rate.price) === 0
          ? 'FRETE GRÁTIS'
          : dependencies.money(Math.round(Number(rate.price) * 100), currency);
        item.textContent = (rate.name || 'Entrega') + ' — ' + price;
        rates.appendChild(item);
      });
    });
    var lowest = lowestRate(available);
    publishQuote(lowest ? {
      price: Math.round(Number(lowest.rate.price) * 100),
      name: lowest.rate.name || 'Entrega',
      currency: currency,
      postalCode: postalCode,
      multiple: lowest.multiple
    } : null);
  }

  function provinceFor(postalCode) {
    var prefix = Number(postalCode.slice(0, 5));
    var ranges = [
      [1000, 19999, 'São Paulo'], [20000, 28999, 'Rio de Janeiro'], [29000, 29999, 'Espírito Santo'],
      [30000, 39999, 'Minas Gerais'], [40000, 48999, 'Bahia'], [49000, 49999, 'Sergipe'],
      [50000, 56999, 'Pernambuco'], [57000, 57999, 'Alagoas'], [58000, 58999, 'Paraíba'],
      [59000, 59999, 'Rio Grande do Norte'], [60000, 63999, 'Ceará'], [64000, 64999, 'Piauí'],
      [65000, 65999, 'Maranhão'], [66000, 68899, 'Pará'], [68900, 68999, 'Amapá'],
      [69000, 69299, 'Amazonas'], [69300, 69399, 'Roraima'], [69400, 69899, 'Amazonas'],
      [69900, 69999, 'Acre'], [70000, 72799, 'Distrito Federal'], [72800, 72999, 'Goiás'],
      [73000, 73699, 'Distrito Federal'], [73700, 76799, 'Goiás'], [76800, 76999, 'Rondônia'],
      [77000, 77999, 'Tocantins'], [78000, 78899, 'Mato Grosso'], [79000, 79999, 'Mato Grosso do Sul'],
      [80000, 87999, 'Paraná'], [88000, 89999, 'Santa Catarina'], [90000, 99999, 'Rio Grande do Sul']
    ];
    for (var index = 0; index < ranges.length; index += 1) {
      if (prefix >= ranges[index][0] && prefix <= ranges[index][1]) return ranges[index][2];
    }
    return '';
  }

  function responseError(response, fallback) {
    return response.text().then(function (body) {
      var message = '';
      try {
        var payload = JSON.parse(body);
        var errors = payload && (payload.errors || payload.error);
        if (typeof errors === 'string') message = errors;
        else if (errors && typeof errors === 'object') {
          message = Object.keys(errors).map(function (key) {
            return String((Array.isArray(errors[key]) ? errors[key].join(' ') : errors[key]) || '');
          }).filter(Boolean).join(' ');
        }
      } catch (error) { message = body; }
      throw new Error(message || fallback);
    });
  }

  function submit(form) {
    var postalCode = String(form.elements.postal_code.value || '').replace(/\D/g, '');
    if (postalCode.length !== 8) {
      invalidate();
      showError('Informe um CEP válido com 8 números.');
      return;
    }
    invalidate();
    var requestRevision = revision;
    setLoading('Consultando opções de entrega…');
    var buttons = document.querySelectorAll('[data-gd-shipping-form] [type="submit"]');
    buttons.forEach(function (button) { button.disabled = true; });
    var address = new URLSearchParams();
    address.set('shipping_address[zip]', postalCode);
    address.set('shipping_address[country]', 'Brazil');
    var province = provinceFor(postalCode);
    if (province) address.set('shipping_address[province]', province);
    dependencies.request(dependencies.rootUrl + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (cart) {
      if (!cart.item_count) throw new Error('Adicione um produto ao carrinho antes de calcular o frete.');
      return fetch(dependencies.rootUrl + 'cart/prepare_shipping_rates.json', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', Accept: 'application/json' },
        body: address.toString()
      }).then(function (response) {
        if (!response.ok && response.status !== 202) return responseError(response, 'Não foi possível iniciar o cálculo do frete.');
        return cart;
      });
    }).then(function (cart) {
      var attempts = 0;
      function poll() {
        return fetch(dependencies.rootUrl + 'cart/async_shipping_rates.json?' + address.toString(), { headers: { Accept: 'application/json' } }).then(function (response) {
          if (response.status === 202 && attempts++ < 8) {
            return new Promise(function (resolve) { window.setTimeout(resolve, 650); }).then(poll);
          }
          if (!response.ok) return responseError(response, 'Não foi possível consultar as opções de entrega. Tente novamente.');
          return response.json();
        });
      }
      return poll().then(function (data) {
        if (requestRevision === revision) showQuote(data, cart.currency, postalCode);
      });
    }).catch(function (error) {
      if (requestRevision === revision) showError(error.message || 'Não foi possível calcular o frete. Tente novamente.');
    }).finally(function () {
      buttons.forEach(function (button) { button.disabled = false; });
    });
  }

  function init(scope, options) {
    dependencies = options || dependencies;
    (scope || document).querySelectorAll('[data-gd-shipping-calculator]').forEach(function (calculator) {
      if (calculator.dataset.gdBound) return;
      calculator.dataset.gdBound = 'true';
      var form = calculator.querySelector('[data-gd-shipping-form]');
      var input = form && form.elements.postal_code;
      var change = calculator.querySelector('[data-gd-shipping-change]');
      if (!form || !input) return;
      input.addEventListener('input', function () {
        var value = formatPostal(input.value);
        invalidate();
        calculators().forEach(function (other) {
          var otherInput = other.querySelector('[data-gd-shipping-form]').elements.postal_code;
          if (otherInput) otherInput.value = value;
        });
      });
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        submit(form);
      });
      if (change) change.addEventListener('click', function () {
        invalidate();
        input.focus();
      });
    });
  }

  function updateShells(cart, subtotal) {
    if (!cart) return;
    document.querySelectorAll('[data-gd-shipping-shell]').forEach(function (shell) {
      var threshold = Number(shell.dataset.gdShippingThreshold || 0);
      var reached = shell.dataset.gdShippingActive === 'true' && threshold > 0 && subtotal >= threshold;
      shell.hidden = !Number(cart.item_count) || reached;
    });
  }

  window.GDShippingUI = {
    init: init,
    invalidate: invalidate,
    updateShells: updateShells,
    findFreeRate: findFreeRate,
    getQuote: function () { return quotedRate; },
    lowestRate: lowestRate,
    estimateSubtotal: estimateSubtotal,
    addDrawerSummary: addDrawerSummary,
    updateSummaries: updateSummaries
  };
})();